<template>
  <div>
    <v-dialog
      v-model="showModal"
      persistent
      fullscreen
    >
      <div class="content-section">
        <h1 class="header-style">
          Timesheet Details
        </h1>
        <p
          v-if="checkTimeSheetDetails && timesheetDetails.project !== null"
          class="subheader-style"
        >
          {{ timesheetDetails.project.name }}
        </p>
        <br>
        <div
          v-if="checkTimeSheetDetails"
          class="card-style"
        >
          <p class="title-text-style">
            Date:
            <font class="value-text-style">
              {{ timesheetDetails.start_time | convertToLocal }}
            </font>
          </p>
          <p class="title-text-style">
            Break Time:
            <font class="value-text-style">
              {{
                timesheetDetails.break_time ? timesheetDetails.break_time : "0"
              }}
              Hrs
            </font>
          </p>
          <p class="title-text-style">
            Notes:
            <font
              v-if="timesheetDetails.notes !== null"
              class="value-text-style"
            >
              {{ timesheetDetails.notes }}
            </font>
            <font
              v-else
              class="value-text-style"
            >
              N/A
            </font>
          </p>
          <p class="title-text-style">
            Start Time:
            <font
              v-if="timesheetDetails.start_time !== null"
              class="value-text-style"
            >
              {{ timesheetDetails.start_time | convertToLocalTimeandDate }}
            </font>
            <font
              v-else
              class="value-text-style"
            >
              N/A
            </font>
          </p>
          <p class="title-text-style">
            End Time:
            <font
              v-if="timesheetDetails.end_time !== null"
              class="value-text-style"
            >
              {{ timesheetDetails.end_time | convertToLocalTimeandDate }}
            </font>
            <font
              v-else
              class="value-text-style"
            >
              N/A
            </font>
          </p>
          <p class="title-text-style">
            Worked Hours:
            <font class="value-text-style">
              {{ timesheetDetails.worked_hour }} Hrs
            </font>
          </p>
          <p class="title-text-style">
            Pay Item:
            <font
              v-if="timesheetDetails.pay_item !== null"
              class="value-text-style"
            >
              {{ timesheetDetails.pay_item.name }}
            </font>
            <font v-else>
              N/A
            </font>
          </p>
        </div>
      </div>
      <v-btn
        fab
        color="#FFF"
        small
        rounded
        elevation="0"
        class="close-button"
        @click="showModal = false"
      >
        <v-icon color="#37474f">
          mdi mdi-close
        </v-icon>
      </v-btn>
      <centre-spinner :loading="loading" />
    </v-dialog>
  </div>
</template>

<script>
import spinner from 'src/views/components/SpinnerCentre';
import moment from 'moment';

export default {
  name: 'TimesheetDetails',
  components: {
    'centre-spinner': spinner,
  },
  filters: {
    convertToLocalTimeandDate (stringDatetime) {
      return moment(stringDatetime).local().format('DD-MM-YYYY hh:mm A');
    },

    convertToLocal (stringDatetime) {
      return moment.utc(stringDatetime).local().format('Do MMMM YYYY');
    },
    formatTimeType (type) {
      if (!type) return '';
      return type.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
    },
  },
  props: {
    timesheetId: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      showModal: true,
      loading: false,
    };
  },
  computed: {
    timesheetDetails () {
      return this.$store.getters['timesheets/getTimesheetDetails'];
    },
    checkTimeSheetDetails () {
      if (Object.keys(this.timesheetDetails).length !== 0) {
        return true;
      }
      return false;
    },
  },
  watch: {
    showModal: function (newval, oldval) {
      if (newval === false) {
        this.$emit('closed');
      }
    },
  },
  async mounted () {
    await this.loadOnMount();
  },
  methods: {
    async loadOnMount () {
      this.loading = true;
      await this.$store
        .dispatch('timesheets/fetchTimesheetDetails', {
          timesheetId: this.timesheetId,
        })
        .then(() => {
          this.loading = false;
        });
      this.loading = false;
    },
  },
};
</script>

<style scoped>
.card-style {
  border-radius: 10px;
  padding: 10px;
  background: #fff;
}

.title-text {
  font-weight: 900;
}
</style>
